module.exports = __webpack_public_path__ + "static/media/Harry S. Truman (I) - 1948.3d83bce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Harry S. Truman (I) - 1948.jpg
// module id = 484
// module chunks = 0